/* LAB recently viewed. Dependency free, loaded with defer.
   1. Reads the current product JSON blob embedded by
      sections/lab-recently-viewed.liquid and pushes it into
      localStorage under 'lab_recent' (max 8 entries, most recent
      first, deduped by handle).
   2. Renders up to 4 OTHER stored entries into the section grid as
      simple cards (image, title, GBP price formatted client-side).
   3. Unhides the section only when there is something to show. */

(function () {
  'use strict';

  var STORE_KEY = 'lab_recent';
  var STORE_MAX = 8;
  var RENDER_MAX = 4;

  function readEntries() {
    var raw;
    try {
      raw = window.localStorage.getItem(STORE_KEY);
    } catch (err) {
      return [];
    }
    if (!raw) return [];

    var parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (err) {
      return [];
    }
    if (!Array.isArray(parsed)) return [];

    return parsed.filter(function (entry) {
      return (
        entry &&
        typeof entry.handle === 'string' &&
        entry.handle !== '' &&
        typeof entry.url === 'string' &&
        entry.url !== '' &&
        typeof entry.title === 'string' &&
        entry.title !== ''
      );
    });
  }

  function writeEntries(entries) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify(entries));
    } catch (err) {
      /* Storage unavailable or full; the strip simply does not persist. */
    }
  }

  /* Prices are subunit integers. Matches the Liquid money output:
     pound sign, thousands commas, pence only when non-zero. */
  function formatPrice(subunits) {
    if (typeof subunits !== 'number' || !isFinite(subunits)) return '';
    var pence = Math.round(subunits);
    var pounds = Math.floor(pence / 100);
    var remainder = pence % 100;
    var out = '£' + pounds.toLocaleString('en-GB');
    if (remainder > 0) {
      out += '.' + (remainder < 10 ? '0' : '') + remainder;
    }
    return out;
  }

  function readCurrentProduct() {
    var el = document.querySelector('script[data-lab-recent-product]');
    if (!el) return null;

    var payload;
    try {
      payload = JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
    if (!payload || typeof payload.handle !== 'string' || payload.handle === '') return null;

    return {
      handle: payload.handle,
      url: typeof payload.url === 'string' ? payload.url : '',
      title: typeof payload.title === 'string' ? payload.title : '',
      price: typeof payload.price === 'number' ? payload.price : null,
      image: typeof payload.image === 'string' ? payload.image : ''
    };
  }

  function buildCard(entry) {
    var card = document.createElement('a');
    card.className = 'lab-recent-card';
    card.href = entry.url;

    var media = document.createElement('figure');
    media.className = 'lab-recent-card__media';
    if (entry.image) {
      var img = document.createElement('img');
      img.className = 'lab-recent-card__img';
      img.src = entry.image;
      img.alt = entry.title;
      img.loading = 'lazy';
      media.appendChild(img);
    }
    card.appendChild(media);

    var meta = document.createElement('div');
    meta.className = 'lab-recent-card__meta';

    var title = document.createElement('p');
    title.className = 'lab-recent-card__title font-display';
    title.textContent = entry.title;
    meta.appendChild(title);

    var priceText = formatPrice(entry.price);
    if (priceText) {
      var price = document.createElement('p');
      price.className = 'lab-recent-card__price tracked-caps';
      price.textContent = priceText;
      meta.appendChild(price);
    }

    card.appendChild(meta);
    return card;
  }

  function init() {
    var section = document.querySelector('[data-lab-recently-viewed]');
    var grid = section ? section.querySelector('[data-lab-recent-grid]') : null;

    var stored = readEntries();
    var current = readCurrentProduct();
    var others = stored;

    if (current) {
      others = stored.filter(function (entry) {
        return entry.handle !== current.handle;
      });
      writeEntries([current].concat(others).slice(0, STORE_MAX));
    }

    if (!section || !grid) return;

    var toShow = others.slice(0, RENDER_MAX);
    if (toShow.length === 0) return;

    for (var i = 0; i < toShow.length; i += 1) {
      grid.appendChild(buildCard(toShow[i]));
    }
    section.removeAttribute('hidden');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
